import { DealerPackageMappedId } from "../../queries/updatePartPackageByPartId";

export const parseVehicleMappingKey = (key: string): DealerPackageMappedId => {
  const [vehicleModelId, vehicleSubmodelId, vehicleYearId] = key.split("-");
  return {
    vehicleModelId,
    vehicleSubmodelId,
    vehicleYearId,
  };
};
